import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import { connect } from 'react-redux';
import { TWSessionBookingOptions } from '.';
import { getServicePlansForAsset as getServicePlansForAssetAction, getSessionAccess as getSessionAccessAction, getUserSessionBookings as getUserSessionBookingsAction } from '../../../state/actions';
import { AssetResourceType } from '../../../interfaces';

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _state$auth, _state$auth$users;

  var sessionResource = ownProps.session ? state.assets.resources[ownProps.session.id] : null;
  var availablePlans = (sessionResource ? sessionResource.plans : []).filter(function (p) {
    return !!p.active;
  });
  var sessionAccess = ownProps.session ? state.session.sessionAccess[ownProps.session.id] : null;
  var existingBooking = ownProps.session ? state.booking.sessionBookings[ownProps.session.id] : null;
  return {
    availablePlans: availablePlans,
    sessionAccess: sessionAccess,
    currentUser: state === null || state === void 0 ? void 0 : (_state$auth = state.auth) === null || _state$auth === void 0 ? void 0 : (_state$auth$users = _state$auth.users) === null || _state$auth$users === void 0 ? void 0 : _state$auth$users.current,
    existingBooking: existingBooking
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getData: function () {
      var _getData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(sessionId, serviceId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return dispatch(getSessionAccessAction(sessionId));

              case 2:
                _context.next = 4;
                return dispatch(getServicePlansForAssetAction({
                  serviceId: serviceId,
                  resourceId: sessionId,
                  resourceType: AssetResourceType.SESSION
                }));

              case 4:
                _context.next = 6;
                return dispatch(getUserSessionBookingsAction(sessionId));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getData(_x, _x2) {
        return _getData.apply(this, arguments);
      }

      return getData;
    }()
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TWSessionBookingOptions);